import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import RouteType from "@Route/types/Route.type";
import {calculateTravelTime} from "@Route/functions/calculateTravelTime";
import median from "@Array/median";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";

export default function getSlowestAndFastestVehClassesInGeneral(transportTypes: TransportTypesType[], singleRoutes: RoutesOrganizedByTransportTypeType) {
    let tempFastest: number
    let tempSlowest: number
    let fastestInGeneralTransportType: TransportTypesType
    let slowestInGeneralTransportType: TransportTypesType

    transportTypes.map((transportType) => {
        const allTravelTimes = singleRoutes[transportType].map((route: RouteType) => (
            calculateTravelTime(route)
        ))

        const timeMedian = median(allTravelTimes)

        if (!tempFastest || tempFastest > timeMedian) {
            tempFastest = timeMedian
            fastestInGeneralTransportType = transportType
        }

        if (!tempSlowest || tempSlowest < timeMedian) {
            tempSlowest = timeMedian
            slowestInGeneralTransportType = transportType
        }
    })

    return {
        slowestInGeneralTransportType,
        fastestInGeneralTransportType,
    }
}